import { AnchorHTMLAttributes, FC, MouseEventHandler, ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from '../../utils/classnames';

type CustomLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    children: ReactNode;
    to?: string;
    activeClassName?: string;
    className?: string;
    isActive?: () => boolean;
    // onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const CustomLink: FC<CustomLinkProps> = ({ to = '/', isActive, className, children, activeClassName, ...rest }) => {
    const location = useLocation();
    const isAbsoluteURL = /^https?:\/\//.test(to);

    if (isAbsoluteURL) {
        return (
            <a className={classNames(className, { activeClassName: location.pathname === to })} href={to} {...rest}>
                {children}
            </a>
        );
    }

    return (
        <NavLink
            className={({ isActive: active }) =>
                classNames(className, {
                    [activeClassName || '']: active || isActive?.()
                })
            }
            to={to}
            {...rest}
        >
            {children}
        </NavLink>
    );
};

export default CustomLink;
